import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function CartHeader({ onClose, title = "Mi Carrito", showBackButton = false, onBack }) {
  return (
    <div className="flex items-center justify-between px-4 pt-4 border-b border-aw-bluedark-50">
      <div className="flex items-center gap-3">
        {showBackButton && (
          <button 
            onClick={onBack}
            className="text-white hover:text-aw-green transition-colors"
          >
            <FontAwesomeIcon icon="fa-solid fa-arrow-left" size="lg" />
          </button>
        )}
        {/* <h2 className="text-white font-bold text-lg">{title}</h2> */}
      </div>
      
      <div className="flex items-center gap-3">
        {/* <div className="flex gap-2 text-[0.65rem] sm:text-xs">
          <button className="bg-red-600 text-white px-2 py-1 rounded font-bold">Chek OUT - Ticket</button>
          <button className="bg-aw-green text-black px-4 py-1 rounded font-bold">Chek Embajador</button>
          <button className="bg-aw-green text-black px-4 py-1 rounded font-bold">Chek STAFF</button>
          </div> */}
        <button onClick={onClose} className="text-white text-xl font-bold hover:text-aw-green">&times;</button>
      </div>
    </div>
  );
}